{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "operate",
  "roles": [
    "director-of-maintenance",
    "maintenance-control",
    "planner",
    "records-specialist",
    "fleet-manager",
    "compliance-manager"
  ],
  "orgTypes": [
    "part-91-owner",
    "corporate-flight-dept",
    "management-company",
    "part-135",
    "fractional",
    "integrated-135-145"
  ],
  "extensions": [
    "conformity-review",
    "prebuy",
    "a025-readiness",
    "data-migration",
    "integrations",
    "premium-support",
    "byom",
    "co-build",
    "ironfleet-network"
  ],
  "integrations": [
    "camp",
    "traxxall",
    "veryon",
    "flight-operations-systems"
  ]
}